<template>
  <html data-wf-page="5b246c8ee77a9371b89449dc" data-wf-site="5b1755d5269b9c5142d82ca3">
<head>
  <meta charset="utf-8">
  <title>Cabinet Manager | Members</title>
  <meta content="width=device-width, initial-scale=1" name="viewport">
</head>
<body class="body">
  <div class="welcomesec1">
    <div class="brand">
      <SignInButton :user="user" @login="$emit('login')"></SignInButton>
    </div>
    <div class="welcome">
      <div class="div-block-21">
        <div class="welcometext">
          <h1 class="heading">Welcome to Cabinet Manager!</h1>
          <p class="paragraph">Tools for manage cabinet projects, generate work flows and track works automatically.</p>
        </div>
        <div class="links"><a href="/" class="link-block w-inline-block"><img src="../../static/images/home.png" width="24" height="24"><div class="text-block">Home</div></a><a href="#" class="link-block-2 w-inline-block"><img src="../../static/images/members.png" width="24" height="24"><div class="text-block-2">Members</div></a></div>
        <!-- <div class="links"><a href="#" class="link-block w-inline-block"><img src="../../static/images/document-green.png" width="24" height="24"><div class="text-block-2">Documentation</div></a><a href="#" class="link-block-2 w-inline-block"><img src="../../static/images/support-green.png" width="24" height="24"><div class="text-block-2">Support</div></a></div> -->
      </div>
    </div>
  </div>
  <div class="projectssec">
    <div class="teamsettingdiv">
      <div class="teamsettingdiv1">
        <div class="teamsettingtitle">Members</div>
      </div>
      <div class="teamsettingitemdiv">
        <div class="teamsettingitemtitle">Users</div>
        <div class="teamsettingmember">
          <el-table
            :data='users.filter(user => {return user.user_level !== 0})'
           >
            <el-table-column
              label=""
              width="64">
              <template slot-scope="scope">
                <img :src="scope.row.photo_url" alt="user icon" width="32px" height="32px" style="border-radius: 16px;">
              </template>
            </el-table-column>
            <el-table-column
              prop="name"
              label="Name">
            </el-table-column>
            <el-table-column
              prop="email"
              label="Email"
              fit="true">
            </el-table-column>
            <el-table-column
              prop="display_level"
              label="Role"
              width="100"
              :filters="[{ text: 'admin', value: 1 }, { text: 'user', value: 2 }]"
              :filter-method="filterRole">
            </el-table-column>
            <el-table-column
              label="Action"
              fit="true">
              <template slot-scope="scope">
                <el-button size="mini" type="warning" round @click="adminUser(scope.row)">Make Admin</el-button>
                <el-button size="mini" type="info" round @click="deleteUser(scope.row)">Delete</el-button>
              </template>
            </el-table-column>
           </el-table>
        </div>
      </div>
      <div class="teamsettingitemdiv">
        <div class="teamsettingitemtitle">Visitors</div>
        <div class="teamsettingmember">
          <el-table
            :data='visitors'
           >
            <el-table-column
              prop="name"
              label="Name"
            >
            </el-table-column>
            <el-table-column
              prop="email"
              label="Email"
              fit="true">
            </el-table-column>
            <el-table-column
              label="Action"
              fit="true">
              <template slot-scope="scope">
                <el-button size="mini" type="primary" round @click="acceptVisitor(scope.row)">Accept</el-button>
                <el-button size="mini" type="info" round @click="deleteVisitor(scope.row)">Delete</el-button>
              </template>
            </el-table-column>
           </el-table>
        </div>
      </div>
    </div>
  </div>
  <div class="powereddiv">
    <div class="div-block-14">
      <div class="text-block-9">Powered by </div>
      <a href="http://studioscreation.com" target="_blank" class="poweredlink w-inline-block">
        <div class="text-block-10">Studio S, Inc.</div>
      </a>
    </div>
  </div>
</body>
</html>
</template>

<script src="https://ajax.googleapis.com/ajax/libs/webfont/1.4.7/webfont.js" type="text/javascript"></script>
<script type="text/javascript">WebFont.load({  google: {    families: ["Ubuntu:300,300italic,400,400italic,500,500italic,700,700italic","Roboto:100,100italic,300,300italic,regular,italic,500,500italic,700,700italic,900,900italic","Dosis:regular,500,600,700,800"]  }});</script>
<!-- [if lt IE 9]><script src="https://cdnjs.cloudflare.com/ajax/libs/html5shiv/3.7.3/html5shiv.min.js" type="text/javascript"></script><![endif] -->
<script type="text/javascript">!function(o,c){var n=c.documentElement,t=" w-mod-";n.className+=t+"js",("ontouchstart"in o||o.DocumentTouch&&c instanceof DocumentTouch)&&(n.className+=t+"touch")}(window,document);</script>
<script src="https://code.jquery.com/jquery-3.3.1.min.js" type="text/javascript" integrity="sha256-FgpCb/KJQlLNfOu91ta32o/NMZxltwRo8QtmkMRdAu8=" crossorigin="anonymous"></script>
<script src="../static/js/t2-cabinets-management-system.js" type="text/javascript"></script>
<!-- [if lte IE 9]><script src="https://cdnjs.cloudflare.com/ajax/libs/placeholders/3.0.2/placeholders.min.js"></script><![endif] -->

<script>
import { db } from '../main'
import SignInButton from './SignInButton.vue'

export default {
  name: 'Users',
  components: {
    SignInButton
  },
  data () {
    return {
      users: [],
      visitors: []
    }
  },
  firestore () {
    return {
      users: db.collection('user').orderBy('user_level'),
      visitors: db.collection('visitor').orderBy('name')
    }
  },
  props: ['user','userLevel'],
  watch: {
    userLevel: function () {
      if(this.user && this.userLevel > 1){
        this.$message({
          showClose: false,
          message: 'Only administrator can set team member, please return',
          type: 'error',
          duration: 0,
          center: true
        })
      }
    }
  },
  mounted: function() {
    if(this.user && this.userLevel > 1){
      this.$message({
        showClose: false,
        message: 'Only administrator can set team member, please return',
        type: 'error',
        duration: 0,
        center: true
      })
    }
  },
  methods: {
    acceptVisitor: function (visitor) {
      // console.log('accept visitor',visitor)
      let newUser = {
        email: visitor.email,
        uid: visitor.uid,
        name: visitor.name,
        photo_url: visitor.photo_url,
        user_level: 2,
        display_level: 'User'
      }
      let deleteOp = db.collection('visitor').doc(visitor.uid).delete()
      let addOp = db.collection('user').doc(visitor.uid).set(newUser)
      Promise.all([deleteOp,addOp]).then(() => {
        this.$message({
          showClose: true,
          message: 'User added successfully.',
          type: 'success',
          duration: 3000,
          center: true
        })
      }).catch(err => {
        this.$message({
          showClose: true,
          message: 'Add user failed, try again later.',
          type: 'error',
          duration: 3000,
          center: true
        })
      })
    },
    deleteVisitor: function (visitor) {
      db.collection('visitor').doc(visitor.uid).delete().then(() => {
        this.$message({
          showClose: true,
          message: 'Visitor deleted',
          type: 'info',
          duration: 3000,
          center: true
        })
      }).catch(() => {
        this.$message({
          showClose: true,
          message: 'Delete visitor failed, try again later.',
          type: 'error',
          duration: 3000,
          center: true
        })
      })
    },
    adminUser: function (user) {
      this.$confirm('Your are going to make this user as admin.', 'Heads Up!', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        let newUser = user
        newUser.user_level = 1
        newUser.display_level = 'Admin'
        db.collection('user').doc(user.uid).set(newUser).then(() => {
          this.$message({
            showClose: true,
            type: 'success',
            message: 'Successfully make the user admin',
            duration: 3000,
            center: true
          })
        }).catch(() => {
          this.$message({
            showClose: true,
            message: 'Make user admin failed, try again later',
            type: 'error',
            duration: 3000,
            center: true
          })
        })
      }).catch(() => {
        this.$message({
          showClose: true,
          message: 'You cancelled the action',
          type: 'info',
          duration: 3000,
          center: true
        })
      })
    },
    deleteUser: function (user) {
      if(user.user_level < 2) {
        this.$message({
          showClose: true,
          message: 'You are not allowed to delete an admin',
          type: 'error',
          duration: 5000,
          center: true
        })
      } else {
        this.$confirm('Your are going to delete this user.', 'Heads Up!', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          db.collection('user').doc(user.uid).delete().then(() => {
            this.$message({
              showClose: true,
              type: 'success',
              message: 'Successfully delete the user',
              duration: 3000,
              center: true
            })
          }).catch(() => {
            this.$message({
              showClose: true,
              message: 'Delete user failed, try again later',
              type: 'error',
              duration: 3000,
              center: true
            })
          })
        }).catch(() => {
          this.$message({
            showClose: true,
            message: 'You cancelled the action',
            type: 'info',
            duration: 3000,
            center: true
          })
        })
      }
    },
    filterRole: function (value, row) {
      return row.user_level === value
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Users.vue